<h1 mat-dialog-title>{{ languageService.languageJSON.ComponentRecalled_BulkUploadResult_Title }}</h1>
<div mat-dialog-content>
    <p>{{ languageService.languageJSON.ComponentRecalled_BulkUploadResult_Desc }}</p>

    <div class="bike-result-element" *ngIf="completedBikesString">
        <p>{{ completedBikesString }}</p>
        <div class="bikes-array">
            <ng-scrollbar>
                <div class="bike-element" *ngFor="let bike of completedBikes">{{ bike }}</div>
            </ng-scrollbar>
        </div>
    </div>

    <div class="bike-result-element" *ngIf="duplicatedBikesString">
        <p>{{ duplicatedBikesString }}</p>
        <div class="bikes-array">
            <ng-scrollbar>
                <div class="bike-element" *ngFor="let bike of duplicatedBikes">{{ bike }}</div>
            </ng-scrollbar>
        </div>
    </div>

    <div class="bike-result-element" *ngIf="notAllowedBikesString">
        <p>{{ notAllowedBikesString }}</p>
        <div class="bikes-array">
            <ng-scrollbar>
                <div class="bike-element" *ngFor="let bike of notAllowedBikes">{{ bike }}</div>
            </ng-scrollbar>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>{{ languageService.languageJSON.Global_Close }}</button>
</div>